"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query userExists(
    $email: String
    $phoneNumber: String
    $promoCode: String
    $eventId: String
    $seasonId: String
  ) {
    userExists(
      email: $email
      phoneNumber: $phoneNumber
      promoCode: $promoCode
      eventId: $eventId
      seasonId: $seasonId
    ) {
      userId
      firstName
      lastName
      email
      hasPassword
      phoneNumberVerifiedAt
      phoneNumber
      preferredLogin
      promoAvailable
      secondaryEmails
      __typename
    }
  }
`;
exports.default = query;
//# sourceMappingURL=userExists.query.js.map